import { render, staticRenderFns } from "./form10.vue?vue&type=template&id=68098aae&scoped=true&"
import script from "./form10.vue?vue&type=script&lang=js&"
export * from "./form10.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68098aae",
  null
  
)

export default component.exports